class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.wishlistItems = localStorage.getItem("wishlist-items")
      ? JSON.parse(localStorage.getItem("wishlist-items"))
      : [];

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#WishlistDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    document.querySelectorAll("[open-wishlist-drawer]").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.open(e.target);
      });
    });
  }

  addItemToWishlist(item) {
    this.wishlistItems.push(item);
    this.wishlistItems = [...new Set(this.wishlistItems)];
    localStorage.setItem("wishlist-items", JSON.stringify(this.wishlistItems));
  }

  removeItemFromWishlist(item) {
    this.wishlistItems = this.wishlistItems.filter((itm) => itm != item); //[...new Set(this.wishlistItems)];
    localStorage.setItem("wishlist-items", JSON.stringify(this.wishlistItems));
  }

  async fetchItem(item) {
    const response = await fetch(`/products/${item}?section=wishlist-card`);
    const data = await response.text();
    return data;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("WishlistDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("wishlist-drawer", WishlistDrawer);

class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.toggleWishlistItem.bind(this));

    this.wishlistDrawer = document.querySelector("wishlist-drawer");

    this.wishlistDrawer.wishlistItems.find(
      (itm) => itm == this.dataset.productHandle
    ) && this.classList.add("active");
  }

  toggleWishlistItem(e) {
    if (this.classList.contains("active")) {
      this.wishlistDrawer.removeItemFromWishlist(this.dataset.productHandle);
      this.classList.remove("active");
    } else {
      this.wishlistDrawer.addItemToWishlist(this.dataset.productHandle);
      this.classList.add("active");
    }
  }
}

customElements.define("wishlist-button", WishlistButton);
